var Duration = function () {
  function Duration(start, end) {
    this.start = start;
    this.end = end;
  }

  Duration.prototype.getLength = function () {
    return this.end - this.start;
  };

  return Duration;
}();

export { Duration };